import React from 'react';

const WordQuestLoadingScreen = () => (
  <div
    role="status"
    aria-label="Loading Word Quest"
    style={{
      minHeight: '100vh',
      boxSizing: 'border-box',
      display: 'grid',
      placeItems: 'center',
      padding: 24,
      color: '#2b2144',
      background: 'linear-gradient(135deg, #fbfcff 0%, #f8f2ff 52%, #fffaf4 100%)',
      fontFamily: "'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    }}
  >
    <div style={{ textAlign: 'center' }}>
      <div
        aria-hidden="true"
        style={{
          width: 48,
          height: 48,
          margin: '0 auto',
          display: 'grid',
          placeItems: 'center',
          borderRadius: 14,
          color: '#7351e9',
          background: '#f0eaff',
          border: '1px solid #e2d6fb',
          fontSize: 17,
          fontWeight: 900,
          letterSpacing: '-.04em',
        }}
      >
        WQ
      </div>
      <div style={{ marginTop: 14, fontSize: 18, fontWeight: 900, letterSpacing: '-.03em' }}>WORD QUEST</div>
      <div style={{ marginTop: 6, color: '#817596', fontSize: 14 }}>Loading your practice space...</div>
      <div
        aria-hidden="true"
        style={{
          width: 72,
          height: 5,
          margin: '18px auto 0',
          borderRadius: 999,
          background: 'linear-gradient(90deg, #7351e9 0%, #cbbaf5 100%)',
        }}
      />
    </div>
  </div>
);

export default WordQuestLoadingScreen;
